// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Suggestion_bckdrp__lH8us {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: transparent;
  z-index: 16000;
}
.Suggestion_container__2USaT {
  position: relative;
  width: 100%;
  background-color: #fff;
}
.Suggestion_editableListContainer__TIFj0 {
  width: 100%;
  background-color: #fff;
}
.Suggestion_optionContainer__flUNQ {
  /* position: absolute; */
  background-color: #fff;
  /* width: 100%; */
  border-radius: 4px;
  z-index: 16001;
  box-shadow: 3px 5px 9px rgb(80 80 80 / 38%);
  padding: 5px 0;
  max-height: 300px;
  overflow-y: auto;
}
.Suggestion_optionContainerEditableList__xyQqz {
  /* position: absolute; */
  background-color: #fff;
  /* width: 300px; */
  border-radius: 4px;
  z-index: 16001;
  box-shadow: 3px 5px 9px rgb(80 80 80 / 38%);
  padding: 5px 0;
  max-height: 300px;
  overflow-y: auto;
  /* transform: translateX(5px); */
}
.Suggestion_option__CuLPv {
  padding: 6px 10px;
  cursor: pointer;
  min-height: 30px;
}
.Suggestion_option__CuLPv:not(.Suggestion_option__CuLPv:last-child) {
  border-bottom: 1px solid #9797977c;
}
.Suggestion_option__CuLPv:hover {
  background-color: rgba(88, 88, 88, 0.1);
}
.Suggestion_activeOption__2Fasq {
  background-color: #c9c9c97c;
}
.Suggestion_txtInput__7dnGg {
  padding-inline-start: 7px;
  padding-block-start: 20px;
  padding-block-end: 8px;
  width: 100%;
  height: 50px;
  transition: all 0.4s ease-out;
  background-color: transparent;
  direction: inherit !important;
}
.Suggestion_txtInputEditableList__USPxm {
  padding-inline-start: 20px;
  padding-block-start: 20px;
  padding-block-end: 5px;
  width: 100%;
  height: 50px;
  transition: all 0.4s ease-out;
  background-color: transparent;
  direction: inherit !important;
}
.Suggestion_label__FLXE8 {
  position: absolute;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  z-index: 0;
  transition: all 0.2s ease-out;
  background-color: transparent;
  padding: 0 4px;
  border-radius: 5px;
}
.Suggestion_labelUp__kc5\\+t {
  top: -10px;
  cursor: default;
}
.Suggestion_editableListLabelUp__Z5RFa {
  top: 8px;
  cursor: default;
  transform: translateX(-29px);
}
.Suggestion_labelDown__wcW2n {
  width: calc(100% - 50px) !important;
  top: 11px;
  cursor: text;
  margin-inline-start: 3px !important;
}
.Suggestion_editableListLabelDown__TyOHR {
  top: 26px;
  font-size: 16px;
  font-weight: 500;
  cursor: text;
  margin-inline-start: 35px !important;
}
.Suggestion_magnifier__Tpvbl {
  position: absolute;
  margin-inline-start: calc(100% - 21px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: all 0.2s ease-out;
  width: 20px;
  height: 20px;
}
.Suggestion_magnifierUp__zkjAW {
  top: 21px;
}
.Suggestion_editableListMagnifierUp__8mK2k {
  top: 9px;
}
.Suggestion_editableListMagnifierUp__8mK2k svg {
  font-size: 20px;
}
.Suggestion_magnifierDown__vmYWC {
  top: 18px;
}
.Suggestion_editableListMagnifierDown__G4juK {
  top: 27px;
}
.Suggestion_mandatorySign__g9RS1 {
  padding-inline-start: 5px;
}
.Suggestion_checkIcon__0N9ub {
  position: absolute;
  top: 18px;
  margin-inline-start: -22px;
  color: var(--focused-input-color);
  fill: var(--focused-input-color);
  font-weight: 900;
}
.Suggestion_multipyIcon__rUOOA {
  position: absolute;
  top: 20px;
  width: 22px;
  height: 22px;
  margin-inline-start: -22px;
  color: var(--invalid-input-color);
  fill: var(--invalid-input-color);
  font-weight: 900;
}
.Suggestion_mounted__RlPkL {
  animation: Suggestion_inAnimationx__-qeUC 250ms ease-in;
}
.Suggestion_unmounted__xMyqa {
  animation: Suggestion_outAnimationx__sqTh2 120ms linear forwards;
}
@keyframes Suggestion_inAnimationx__-qeUC {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}

@keyframes Suggestion_outAnimationx__sqTh2 {
  0% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
.Suggestion_tooltip__hQi8d {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.4s;
  z-index: 1;
  pointer-events: none; /* Prevent the tooltip from interfering with cursor */
  font-size: 12px;
}
.Suggestion_container__2USaT:hover .Suggestion_tooltip__hQi8d {
  visibility: visible;
  opacity: 1;
}
.Suggestion_tooltip__hQi8d::after {
  content: "";
  position: absolute;
  top: 100%; /* Position the arrow at the bottom of the tooltip */
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px; /* Size of the arrow */
  border-style: solid;
  border-color: #333 transparent transparent transparent; /* Triangle color and transparent sides */
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/SuggestionV2/Suggestion.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,SAAS;EACT,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,uDAAqC;AACvC;AACA;EACE,gEAA8C;AAChD;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,UAAU;EACV,oBAAoB,EAAE,qDAAqD;EAC3E,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,oDAAoD;EAC/D,SAAS;EACT,2BAA2B;EAC3B,iBAAiB,EAAE,sBAAsB;EACzC,mBAAmB;EACnB,sDAAsD,EAAE,yCAAyC;AACnG","sourcesContent":[".bckdrp {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: transparent;\r\n  z-index: 16000;\r\n}\r\n.container {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: #fff;\r\n}\r\n.editableListContainer {\r\n  width: 100%;\r\n  background-color: #fff;\r\n}\r\n.optionContainer {\r\n  /* position: absolute; */\r\n  background-color: #fff;\r\n  /* width: 100%; */\r\n  border-radius: 4px;\r\n  z-index: 16001;\r\n  box-shadow: 3px 5px 9px rgb(80 80 80 / 38%);\r\n  padding: 5px 0;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n.optionContainerEditableList {\r\n  /* position: absolute; */\r\n  background-color: #fff;\r\n  /* width: 300px; */\r\n  border-radius: 4px;\r\n  z-index: 16001;\r\n  box-shadow: 3px 5px 9px rgb(80 80 80 / 38%);\r\n  padding: 5px 0;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  /* transform: translateX(5px); */\r\n}\r\n.option {\r\n  padding: 6px 10px;\r\n  cursor: pointer;\r\n  min-height: 30px;\r\n}\r\n.option:not(.option:last-child) {\r\n  border-bottom: 1px solid #9797977c;\r\n}\r\n.option:hover {\r\n  background-color: rgba(88, 88, 88, 0.1);\r\n}\r\n.activeOption {\r\n  background-color: #c9c9c97c;\r\n}\r\n.txtInput {\r\n  padding-inline-start: 7px;\r\n  padding-block-start: 20px;\r\n  padding-block-end: 8px;\r\n  width: 100%;\r\n  height: 50px;\r\n  transition: all 0.4s ease-out;\r\n  background-color: transparent;\r\n  direction: inherit !important;\r\n}\r\n.txtInputEditableList {\r\n  padding-inline-start: 20px;\r\n  padding-block-start: 20px;\r\n  padding-block-end: 5px;\r\n  width: 100%;\r\n  height: 50px;\r\n  transition: all 0.4s ease-out;\r\n  background-color: transparent;\r\n  direction: inherit !important;\r\n}\r\n.label {\r\n  position: absolute;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  z-index: 0;\r\n  transition: all 0.2s ease-out;\r\n  background-color: transparent;\r\n  padding: 0 4px;\r\n  border-radius: 5px;\r\n}\r\n.labelUp {\r\n  top: -10px;\r\n  cursor: default;\r\n}\r\n.editableListLabelUp {\r\n  top: 8px;\r\n  cursor: default;\r\n  transform: translateX(-29px);\r\n}\r\n.labelDown {\r\n  width: calc(100% - 50px) !important;\r\n  top: 11px;\r\n  cursor: text;\r\n  margin-inline-start: 3px !important;\r\n}\r\n.editableListLabelDown {\r\n  top: 26px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  cursor: text;\r\n  margin-inline-start: 35px !important;\r\n}\r\n.magnifier {\r\n  position: absolute;\r\n  margin-inline-start: calc(100% - 21px);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  transition: all 0.2s ease-out;\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.magnifierUp {\r\n  top: 21px;\r\n}\r\n.editableListMagnifierUp {\r\n  top: 9px;\r\n}\r\n.editableListMagnifierUp svg {\r\n  font-size: 20px;\r\n}\r\n.magnifierDown {\r\n  top: 18px;\r\n}\r\n.editableListMagnifierDown {\r\n  top: 27px;\r\n}\r\n.mandatorySign {\r\n  padding-inline-start: 5px;\r\n}\r\n.checkIcon {\r\n  position: absolute;\r\n  top: 18px;\r\n  margin-inline-start: -22px;\r\n  color: var(--focused-input-color);\r\n  fill: var(--focused-input-color);\r\n  font-weight: 900;\r\n}\r\n.multipyIcon {\r\n  position: absolute;\r\n  top: 20px;\r\n  width: 22px;\r\n  height: 22px;\r\n  margin-inline-start: -22px;\r\n  color: var(--invalid-input-color);\r\n  fill: var(--invalid-input-color);\r\n  font-weight: 900;\r\n}\r\n.mounted {\r\n  animation: inAnimationx 250ms ease-in;\r\n}\r\n.unmounted {\r\n  animation: outAnimationx 120ms linear forwards;\r\n}\r\n@keyframes inAnimationx {\r\n  0% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n@keyframes outAnimationx {\r\n  0% {\r\n    opacity: 0.8;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n}\r\n.tooltip {\r\n  visibility: hidden;\r\n  background-color: #333;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 5px 10px;\r\n  border-radius: 4px;\r\n  position: absolute;\r\n  bottom: calc(100% + 10px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  transition: opacity 0.4s;\r\n  z-index: 1;\r\n  pointer-events: none; /* Prevent the tooltip from interfering with cursor */\r\n  font-size: 12px;\r\n}\r\n.container:hover .tooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.tooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%; /* Position the arrow at the bottom of the tooltip */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px; /* Size of the arrow */\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent; /* Triangle color and transparent sides */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bckdrp": `Suggestion_bckdrp__lH8us`,
	"container": `Suggestion_container__2USaT`,
	"editableListContainer": `Suggestion_editableListContainer__TIFj0`,
	"optionContainer": `Suggestion_optionContainer__flUNQ`,
	"optionContainerEditableList": `Suggestion_optionContainerEditableList__xyQqz`,
	"option": `Suggestion_option__CuLPv`,
	"activeOption": `Suggestion_activeOption__2Fasq`,
	"txtInput": `Suggestion_txtInput__7dnGg`,
	"txtInputEditableList": `Suggestion_txtInputEditableList__USPxm`,
	"label": `Suggestion_label__FLXE8`,
	"labelUp": `Suggestion_labelUp__kc5+t`,
	"editableListLabelUp": `Suggestion_editableListLabelUp__Z5RFa`,
	"labelDown": `Suggestion_labelDown__wcW2n`,
	"editableListLabelDown": `Suggestion_editableListLabelDown__TyOHR`,
	"magnifier": `Suggestion_magnifier__Tpvbl`,
	"magnifierUp": `Suggestion_magnifierUp__zkjAW`,
	"editableListMagnifierUp": `Suggestion_editableListMagnifierUp__8mK2k`,
	"magnifierDown": `Suggestion_magnifierDown__vmYWC`,
	"editableListMagnifierDown": `Suggestion_editableListMagnifierDown__G4juK`,
	"mandatorySign": `Suggestion_mandatorySign__g9RS1`,
	"checkIcon": `Suggestion_checkIcon__0N9ub`,
	"multipyIcon": `Suggestion_multipyIcon__rUOOA`,
	"mounted": `Suggestion_mounted__RlPkL`,
	"inAnimationx": `Suggestion_inAnimationx__-qeUC`,
	"unmounted": `Suggestion_unmounted__xMyqa`,
	"outAnimationx": `Suggestion_outAnimationx__sqTh2`,
	"tooltip": `Suggestion_tooltip__hQi8d`
};
export default ___CSS_LOADER_EXPORT___;
